
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import TransferButton from "@/components/general/TransferButton.vue";
import {globalEventBus} from "@/main";
import GridForm from "@/components/general/GridForm.vue";
import UploadButton from "@/components/general/UploadButton.vue";
import {AsyncServieCallType} from "@/assets/js/models/AsyncServiceCallType";


@Component({
    components: {UploadButton, GridForm, TransferButton}
})
export default class TransferComponent extends Vue {
    @Prop({default: -1})
    private connectionState!: number;
    private transferValue = 0;
    @Prop({default: false})
    private isTransmitting!: boolean;
    private transferOption = 1;
    private showHistory = false;
    @Watch('transferValue')
    private transferOptionChanged() {
        if (this.transferValue === 3) {
            this.transferOption = 2;
        } else {
            this.transferOption = 1;
        }
    }

    private transmitCheckoutData = false;

    private get transferItems() {
        return [
            {id: 0, text: 'Bitte wählen'},
            {id: 1, text: 'Artikel & Preise'},
            {id: 2, text: 'Lieferscheinkunden'},
            {id: 3, text: 'Stammdaten'},
            {id: 4, text: 'Kassendaten'}]
    }

    private get context(): string {
        return `Filiale=${this.$store.getters["Auth/branchId"]}`;
    }
    private get loadingColor(): string {
        switch (this.connectionState) {
            case 3:
                return "error";
            case 0:
                return "error";
            default:
                return "info";
        }
    }
    private get infoText(): string {
        // nicht verbunden=0,
        // inaktiv=1,
        // aktiv=2,
        // Connect-Dienst nicht bereit=3
        if (this.isTransmitting && this.connectionState < 4) {
            const value = this.connectionState;
            switch (value) {
                case 3:
                    return "Der APRO.CON Connect-Dienst ist nicht bereit.";
                case 2:
                    return "Eine Übertragung läuft...";
                case 1:
                    return "Eine Übertragung läuft...";
                case 0:
                    return "Der APRO.CON Connect-Dienst ist nicht verbunden."
                case -1:
                    return "Eine Übertragung wurde gestartet."
            }
        }
        return "";
    }
    private async transferItem(): Promise<void> {
        console.log(this.connectionState);
        let callType = undefined;
        try{
            let taskId= undefined;
            switch (this.transferValue) {
                case 1:
                    //artikel
                    taskId = await this.$ports.posManager.sendArticle(this.transferOption);
                    callType = AsyncServieCallType.send_Artikel;
                    break;
                case 2:
                    //kunden
                    taskId= await this.$ports.posManager.sendMCustomers(this.transferOption);
                    callType = AsyncServieCallType.send_Kunden;
                    break;
                case 3:
                    //stammdaten
                    taskId= await this.$ports.posManager.sendMasterdata(this.transferOption);
                    callType = AsyncServieCallType.send_Stammdaten;
                    break;
                case 4:
                    //kassendaten
                    taskId=await this.$ports.posManager.sendScaleData(this.transferOption);
                    callType = AsyncServieCallType.send_Kassendaten;
                    break;
            }

            if(taskId) {

                const tasks = this.$store.getters["Base/tasks"];
                tasks.push({
                    Nummer: taskId,
                    Type: callType
                });
                this.$store.commit("Base/setTasks", tasks);
                globalEventBus.$emit('transferChanged',{isTransmitting:true, title : "Waagen und Kassen / Übertragung"});
            }


            this.$emit('update:connectionState', -1);
            this.transmitCheckoutData = false;
        }catch(e:any) {
            globalEventBus.$emit("showError", e.message);
        }

    }


    private get transferButtonDisabled(): boolean {
        if(this.isTransmitting) {
            return false;
        } else {
            if (this.transferValue === 4) {
                return !this.transmitCheckoutData;
            } else {
                const disabled = this.transferValue === 0;
                return disabled;
            }
        }
    }


    private get disabled():boolean {
        const config = JSON.parse(localStorage.getItem('Auth/userConfig')||'');
        console.info(config);
        if(config && config?.permissions) {
            return config.permissions.DATENSENDEN === 0;
        }
        return false;
    }
}
